import { env } from 'next-runtime-env'

const ensureEnvVariables = <T = unknown>(value: T, fn: string) => {
  // use == to check if value is null or undefined
  if (value == null) {
    throw new Error(
      `Environment variable is not set, please check your ${fn} function or .env file`,
    )
  }

  return value
}

export const getWorldsDomain = () => {
  return ensureEnvVariables(env('NEXT_PUBLIC_WORLDS_DOMAIN'), 'getWorldsDomain')
}

export const getCreateDomain = () => {
  return ensureEnvVariables(env('NEXT_PUBLIC_CREATE_DOMAIN'), 'getCreateDomain')
}

export const getCurrentDomain = () => {
  const hostname = window.location.hostname

  const createDomain = getCreateDomain()
  const worldsDomain = getWorldsDomain()

  return createDomain?.includes(hostname) ? createDomain : worldsDomain || hostname
}

export const getCmsBaseURL = (isSSR: boolean = false) => {
  if (isSSR) {
    return ensureEnvVariables(env('CMS_SERVER'), 'getCmsBaseURL')
  }
  return ensureEnvVariables(env('NEXT_PUBLIC_CMS_SERVER'), 'getCmsBaseURL')
}

export const getShareComponentSDKUri = () => {
  return ensureEnvVariables(env('NEXT_PUBLIC_SHARE_COMPONENT_SDK_URI'), 'getShareComponentSDKUri')
}

export const getViveAvatarDomain = () => {
  return ensureEnvVariables(env('NEXT_PUBLIC_VIVE_AVATAR_DOMAIN'), 'getViveAvatarDomain')
}

export const getCommunityServiceBaseURL = () => {
  return ensureEnvVariables(
    env('NEXT_PUBLIC_COMMUNITY_SERVICE_BASE_URL'),
    'getCommunityServiceBaseURL',
  )
}

export const getMarketBaseURL = () => {
  const isLocal = process.env.NODE_ENV === 'development'

  if (isLocal) {
    return '/api/market/proxy'
  }
  return ensureEnvVariables(env('NEXT_PUBLIC_MARKET_SERVER'), 'getMarketBaseURL')
}

export const enableExamplePage = () => {
  return process.env.NODE_ENV === 'development'
}

export const enableLoginStatusCheck = () => {
  return process.env.NODE_ENV !== 'development'
}

export const enableDevShareComponent = () => {
  return process.env.NODE_ENV === 'development' && typeof window !== 'undefined'
}

export const enableCookieDomain = () => {
  return process.env.NODE_ENV !== 'development'
}
